import React from "react";
import bggrid from "../../assets/About/grid_back.svg";

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[30vh] md:min-h-[60vh] flex items-center justify-center overflow-hidden bg-[linear-gradient(to_bottom,_rgba(40,110,207,0.8)_0%,_rgba(97,158,236,0.7)_25%,_rgba(174,207,251,0.6)_55%,_rgba(255,255,255,0)_85%)]">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img
          src={bggrid}
          alt="Background"
          className="w-full h-full object-cover  opacity-55"
        />
      </div>

      {/* Content */}
      <div className="container mx-auto px-4 sm:px-6 md:px-[60px] lg:px-[120px] max-w-[1200px] py-16 md:py-0 relative z-10 flex flex-col items-center justify-center h-full">
        <div className="max-w-4xl mx-auto text-center transform md:-translate-y-10">
          <h1 className="text-[32px] sm:text-[40px] md:text-[48px]  font-extrabold leading-tight md:leading-[1.1] font-montserrat text-center">
            <span className="bg-gradient-to-r from-black to-[#0060C7] bg-clip-text text-transparent block">
              Agility of a Startup
            </span>
            <span className="bg-gradient-to-r from-black to-[#0060C7] bg-clip-text text-transparent block">
              Maturity of an Enterprise
            </span>
          </h1>

          <p className="mt-3 text-[#333] text-[16px] sm:text-[18px] md:text-[20px] font-normal font-montserrat">
            Partnering with enterprises to innovate at startup speed with the
            reliability they demand.
          </p>
        </div>
      </div>
    </section>
  );
}
